module.exports = __webpack_public_path__ + "img/shuiliang.371dc1f6.png";